function sleep(_0x2c77bf,_0x57f79b){var _0x3c123e=0x0,_0x4d9a75=setInterval(function(){_0x3c123e++;if(_0x3c123e>=_0x2c77bf){clearInterval(_0x4d9a75);if(_0x57f79b)_0x57f79b();}},0x3e8);}

/*
Displays preoreder information on the product detail page.
*/

document.addEventListener('DOMContentLoaded', function() {
  sleep(0.1, function () {
    var preorderButton = document.querySelector('.gPreorderBtn');
    if (preorderButton != null) {
      console.log(preorderButton);
      var preorderInfoHr = document.getElementById("preorder_info_hr_tag");
      var preorderInfo = document.getElementById("preorder_info");

      preorderInfoHr.style.display = "block";
      preorderInfo.style.display = "block";
    }
  });
});